import React from 'react';
import { WrappedCard } from '../WrappedCard';

interface WingonomicsCardProps {
  username?: string;
}

export const WingonomicsCard: React.FC<WingonomicsCardProps> = ({ username }) => {
  return (
    <WrappedCard className="relative" username={username}>
      <div className="space-y-3 md:space-y-4 relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-yellow-300 to-amber-200 bg-clip-text text-transparent mb-3 md:mb-4 drop-shadow-2xl text-center px-2">
          <span className="whitespace-nowrap">Occupy Wingate</span> <span className="inline-block not-italic ml-1">🐋</span>
        </h2>
        
        {/* Wingi Index image */}
        <div className="flex justify-center mb-3 md:mb-4">
          <div className="relative w-full max-w-xs md:max-w-sm">
            <div className="absolute inset-0 bg-yellow-400 blur-3xl opacity-40 animate-pulse"></div>
            <img
              src="/wingi_index.png"
              alt="Wingonomics"
              className="relative w-full h-auto rounded-2xl border-4 border-yellow-400 shadow-2xl"
              style={{ maxHeight: '220px', objectFit: 'cover' }}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </div>
        </div>
        
        <div className="bg-black/60 backdrop-blur-md rounded-2xl p-3 md:p-4 border-2 border-yellow-400/50 shadow-2xl mb-3">
          <p className="text-sm md:text-base text-yellow-200 font-semibold text-center italic mb-2">
            "In the ledger, patterns emerge. In the data, truth runs free."
          </p>
          <p className="text-xs md:text-sm text-yellow-300 text-center font-bold">
            — Coach DAISY
          </p>
        </div>
        
        <a
          href="https://wingo320.com/wingonomics"
          target="_blank"
          rel="noopener noreferrer"
          data-no-navigate="true"
          className="block text-center relative z-50"
          style={{ pointerEvents: 'auto', touchAction: 'manipulation' }}
          onClick={(e) => {
            console.log('[DIAG] WingonomicsCard link onClick fired');
            e.stopPropagation();
            window.open('https://wingo320.com/wingonomics', '_blank', 'noopener,noreferrer');
          }}
          onTouchStart={(e) => {
            console.log('[DIAG] WingonomicsCard link onTouchStart fired');
            e.stopPropagation();
          }}
          onTouchEnd={(e) => {
            console.log('[DIAG] WingonomicsCard link onTouchEnd fired');
            e.stopPropagation();
            window.open('https://wingo320.com/wingonomics', '_blank', 'noopener,noreferrer');
          }}
          onTouchMove={(e) => {
            console.log('[DIAG] WingonomicsCard link onTouchMove fired');
          }}
        >
          <div className="bg-yellow-500/20 backdrop-blur-sm rounded-xl p-3 border-2 border-yellow-400/50 hover:bg-yellow-500/30 transition-colors">
            <p className="text-sm md:text-base text-yellow-200 font-bold">
              Learn about the Wingi Index
            </p>
          </div>
        </a>
      </div>
    </WrappedCard>
  );
};

